import React from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import BrandStrip from "@/components/landing/BrandStrip";
import Differentiators from "@/components/landing/Differentiators";
import Areas from "@/components/landing/Areas";
import Testimonial from "@/components/landing/Testimonial";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <main className="bg-background text-foreground" data-testid="landing-root">
      <Header />
      <Hero />
      <About />
      <Services />
      <BrandStrip />
      <Differentiators />
      <Areas />
      <Testimonial />
      <Contact />
      <Footer />
    </main>
  );
}
